export const loopStatement = /(?:For(?:In|Of)?|While)Statement/;
